/*
 * Package Import
 */
import produce from 'immer';
import type { AnyAction } from 'redux';

/*
 * Local Import
 */
import * as types from 'src/store/types';

/**
 * Types
 */
export interface TrackingState {
  trackingStatus: boolean;
}

/*
 * Initial State
 */
const initialState: TrackingState = {
  trackingStatus: false,
};

/*
 * Reducer for tracking activities (not MixPanel)
 */

/* eslint-disable-next-line @typescript-eslint/default-param-last */
export default (state = initialState, action: AnyAction) =>
  /* eslint-disable-next-line consistent-return */
  produce(state, (draft) => {
    switch (action.type) {
      case types.CHANGE_TRACKING_STATUS:
        draft.trackingStatus = action.isEvent;
        break;

      default:
        return state;
    }
  });
